module.exports = __webpack_public_path__ + "img/shenyang-map.96a1e96b.png";